import { createAction, props } from '@ngrx/store';
import { Breadcrumb } from '../../models/breadcrumbs.model';
import { SelectedOrganizationFilters, SelectedProgramFilters } from '../../models/filters.model';
import { Organization, Site } from '../../models/organization.model';
import { PerformanceInterval } from '../../models/performance-chart.model';
import { ProgramOrganizationType } from '../../models/program-organization.model';
import { Product, Program } from '../../models/program.model';
import { Role } from '../../models/role.model';
import { User } from '../../models/user.model';
import { PerformanceEvent, PerformanceEventKind } from '../../models/performance-event.model';
import { RegistrationTableRow } from '../../models/performance-view.model';

// User actions
export const userReceived = createAction('[Window Event] User Profile Received', props<{ user: User }>());

// Roles actions
export const rolesReceived = createAction('[Navbar API] Roles Received', props<{ roles: Role[] }>());

// Tabs actions
export const setActiveTab = createAction('[Tabs] Set Active Tab', props<{ tabIndex: number }>());

// View mode actions
export const setViewMode = createAction('[View Mode] Set View Mode', props<{ viewMode: ProgramOrganizationType }>());

// Breadcrumbs actions
export const setBreadcrumbs = createAction('[Breadcrumbs] Set Breadcrumbs', props<{ breadcrumbs: Breadcrumb[] }>());

// Filters actions
export const setFilters = createAction('[Filters] Set Filters', props<{ filters: SelectedProgramFilters | SelectedOrganizationFilters }>());
export const loadPrograms = createAction('[Filters] Load Programs');
export const programsLoaded = createAction('[Filters] Programs Loaded', props<{ programs: Program[]; defaultFilters: SelectedProgramFilters | undefined }>());
export const loadProgramsError = createAction('[Filters] Load Programs Error', props<{ error: string }>());

// Organization actions
export const loadOrganizations = createAction('[Filters] Load Organizations');
export const organizationsLoaded = createAction(
  '[Filters] Organizations Loaded',
  props<{ organizations: Organization[]; defaultFilters: SelectedOrganizationFilters | undefined }>()
);
export const loadOrganizationsError = createAction('[Filters] Load Organizations Error', props<{ error: string }>());

// Sites for Organization actions
export const loadSitesForOrganization = createAction('[Filters] Load Sites For Organization', props<{ organizationId: string }>());
export const sitesForOrganizationLoaded = createAction('[Filters] Sites For Organization Loaded', props<{ organizationId: string; sites: Site[] }>());
export const loadSitesForOrganizationError = createAction('[Filters] Load Sites For Organization Error', props<{ error: string }>());

// Products for Program actions
export const loadProductsForProgram = createAction('[Filters] Load Products For Program', props<{ programId: string }>());
export const productsForProgramLoaded = createAction('[Filters] Products For Program Loaded', props<{ programId: string; products: Product[] }>());
export const loadProductsForProgramError = createAction('[Filters] Load Products For Program Error', props<{ error: string }>());

// Site performances actions
export const loadSitePerformanceEvents = createAction(
  '[Site Performances] Load',
  props<{ siteIds: string[]; startDttm: string; endDttm: string; organization: { id: string; name: string } }>()
);
export const sitePerformanceEventsLoaded = createAction('[Site Performances] Loaded', props<{ performances: PerformanceEvent[] }>());
export const loadSitePerformanceEventsError = createAction('[Site Performances] Error', props<{ error: string }>());

// Selected event
export const selectPerformanceEvent = createAction(
  '[Performance Event] Select',
  props<{ kind: PerformanceEventKind; eventId: string; siteId?: string; productId?: string }>()
);

// Site performance interval data actions
export const loadSitePerformanceIntervalData = createAction('[Site Performance Interval] Load', props<{ siteId: string; eventId: string }>());
export const sitePerformanceIntervalDataLoaded = createAction('[Site Performance Interval] Loaded', props<{ performanceData: PerformanceInterval[] }>());
export const loadSitePerformanceIntervalDataError = createAction('[Site Performance Interval] Error', props<{ error: string }>());

export const loadProductPerformanceIntervalData = createAction('[Product Performance Interval] Load', props<{ productId: string; eventId: string }>());

// Product performances actions
export const loadProductPerformanceEvents = createAction(
  '[Product Performances] Load',
  props<{ productIds: string[]; startDttm: string; endDttm: string; program: { id: string; name: string } }>()
);
export const productPerformanceEventsLoaded = createAction('[Product Performances] Loaded', props<{ performances: PerformanceEvent[] }>());
export const loadProductPerformanceEventsError = createAction('[Product Performances] Error', props<{ error: string }>());

export const loadProductSitePerformances = createAction('[Product Site Performances] Load', props<{ productId: string; eventId: string }>());
export const productSitePerformancesLoaded = createAction('[Product Site Performances] Loaded', props<{ performances: RegistrationTableRow[] }>());
export const loadProductSitePerformancesError = createAction('[Product Site Performances] Error', props<{ error: string }>());
